import { createElement } from 'react';
import { redirect, RouteObject } from 'react-router-dom';

import { calendarLayoutPageRoute } from 'pages/CalendarLayout';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';

import { calendarsService, calendarStore, PAGE_SIZE, DEFAULT_SORT_ORDER, DEFAULT_ACTIVE } from 'entities/calendar';

import { pathKeys } from 'shared/lib/react-router';

import CalendarPage from './CalendarsPage';

export const calendarsPageRoute: RouteObject = {
  path: pathKeys.calendars.root(),
  children: [
    {
      index: true,
      element: createElement(CalendarPage),
      loader: async (args) => {
        const requiredPermissions = replacePermissions(pathPermissions.calendars.root, args.params);
        if (!isHasAccess(requiredPermissions)) {
          return redirect(pathKeys.dashboard());
        }
        const year = calendarStore.getState().selectedYear;
        const searchName = calendarStore.getState().searchQuery;

        Promise.resolve(
          calendarsService.prefetchQuery({
            active: DEFAULT_ACTIVE,
            size: PAGE_SIZE,
            year: year.toString(),
            searchName,
            sort: DEFAULT_SORT_ORDER,
          }),
        );
        return args;
      },
    },
    calendarLayoutPageRoute,
  ],
};
